/**
* Web Service handler to retrieve and represent a list of resources
* at a location or Merchant
*
* @class ResourcesWS
*/
var ResourcesWS = function (parent) {
  var self = this; // Convenience reference so the context of 'this' becomes clearer

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(this, arguments);

  self.name = 'ResourcesWS';			// Convenience name for debugging
  self.locationId = ko.observable(null);		// If set, requests resources from one location
  self.requesting = ko.observable(false);		// Boolean. Determines if data is being requested
  self.resources = ko.observableArray([]);	// Collection of resources returned from the service
  self.resourceIds = ko.observableArray([]);


	/**
	* API Endpoint
	*
	* @method serviceURL
	* @return {String}
	*/
  self.serviceURL = ko.computed(function () {
    return '/qless/api/v1/employee/resources';
  });


	/**
	* This method requests data from the service
	*
	* @method doRequest
	* @param {Function} fCallback Function to be run once data has been processed
	* @return {ResourceWS} Returns the object as chainable, for best practice
	*/
  self.doRequest = function () {
    if (qcal.queuesWS.allQueueIds().length > 0) {

      // Set the requesting boolean flag to true
      self.requesting(true);

      qcal.setStatusMessage('Requesting resources');

      // Only request resources for loaded queues
      self.addParam('queueIds', qcal.queuesWS.allQueueIds().join(','));

      // Call the super-method
      AbstractWS.prototype.doRequest.apply(self, arguments);
    }

    // Return self (ResourceWS) to be chainable, for best practice
    return self;
  };


  /**
   * Finds a resource by id
   *
   * @method getResourceById
   * @param {Number} id
   * @returns {ResourceModel | Null}
   */
  self.getResourceById = function (id) {
    return self.resources().find(function (resource) {
      return resource.id === id;
    });
  };

	/**
	* Method to return a collection of all resources that belong to a location
	*
	* @method getResourcesByLocationId
	* @param {Integer} getResourcesByLocationId The location id of the resource to find
	* @return {Array} Returns collection of resources found
	*/
  self.getResourcesByLocationId = function (iLocationId) {
    return self.resources().filter(function (r) {
      return (r.locationId() == iLocationId);
    });
  };


	/**
	* This method iterates over the data returned from the service and
	* converts the individual nodes into ResourceModels and then assigns
	* them to this object's resources collection.
	*
	* @method processData
	* @param {XMLString} xmlData XML data returned from the service
	* @return {ResourceWS} Returns the object as chainable, for best practice
	*/
  self.processData = function (xmlData) {
    var aRsrcs = [],
      aTemp = [],
      aTempIds = [];

    qcal.setStatusMessage('Resources received', 1000);

    // Remove any pre-existing ResourceModels from the collections
    self.resources.removeAll();

    // Call the superclass method to perform any core actions
    AbstractWS.prototype.processData.call(self, xmlData);

    // Iterate over the data to create a ResourceModel for each
    // node of data returned and add it to the self.resources collection
    aRsrcs = $(xmlData).find('resource').toArray();

    // Add a new RousourceModel to the resources collection
    aRsrcs.forEach(function (r) {
      var oRsrcModel = new ResourceModel(r);

      aTemp.push(oRsrcModel);
      aTempIds.push(oRsrcModel.id);

      if (qcal.prevSelectedLocationIds.indexOf(oRsrcModel.locationId().toString()) == -1) {
        qcal.selectedResources.push(oRsrcModel.id.toString());
      }
    });

    // Set the resources collection to the temporary collection of ResourceModels
    // This prevents successive firing of any methods or observables
    // that are bound to this collection.
    self.resources(aTemp);
    self.resourceIds(aTempIds);

    // If the selectedResources collection is empty, there is a
    // high likelihood that this is the first time this service has
    // been run, so select all the resource options
    if (qcal.selectedResources().length == 0) {

      self.resources().forEach(function (r) {

        qcal.availableLocations().forEach(function (avail) {
          if (avail.resources().indexOf(r) > -1) {
            qcal.selectedResources.push(r.id.toString());
          }
        });

      });
    }

    // Set the boolean flag to false, as data requesting is complete
    self.requesting(false);

    // Return self (ResourceWS) to be chainable, for best practice
    return self;
  };

  return self;
};

ResourcesWS.prototype = AbstractWS.prototype;
ResourcesWS.prototype.constructor = ResourcesWS;
